import { StoreListResp } from "domain/payload/response/store/StoreListResp";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import StoreManageService from "service/StoreManageService";

const ManageStorePage: React.FC = () => {
  const navigate = useNavigate();

  const [tab, setTab] = useState<"semua" | "aktif" | "nonaktif">("semua");
  const [stores, setStores] = useState<StoreListResp[]>([]);
  const [loading, setLoading] = useState(true);

  const storeManageService = StoreManageService();

  const loadStores = async () => {
    try {
      const res = await storeManageService.storeList();
      if (res?.data) {
        setStores(res.data);
      }
    } catch (err) {
      console.error("Error fetching store list:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadStores();
  }, []);

  const filtered = stores.filter((store) => {
    if (tab === "semua") return true;
    if (tab === "aktif") return store.active === true;
    if (tab === "nonaktif") return store.active === false;
    return true;
  });

  const SkeletonStoreCard = () => (
    <div className="card mb-3 border" style={{ borderColor: "#dcdcdc" }}>
      <div className="card-body d-flex">
        <div className="skeleton" style={{ width: 110, height: 90, borderRadius: 6 }} />
        <div className="ms-3 flex-grow-1">
          <div className="skeleton" style={{ width: "70%", height: 16, marginBottom: 10 }} />
          <div className="skeleton" style={{ width: "90%", height: 12, marginBottom: 10 }} />
          <div className="skeleton" style={{ width: "60%", height: 12 }} />
        </div>
      </div>
    </div>
  );


  return (
    <div className="container bg-white rounded-top pb-5">
      <div className="d-flex gap-2 mt-3">
        <button
          className={`btn flex-fill ${tab === "semua" ? "btn-primary" : "btn-outline-secondary"}`}
          onClick={() => setTab("semua")}
        >
          Semua
        </button>

        <button
          className={`btn flex-fill ${tab === "aktif" ? "btn-primary" : "btn-outline-secondary"}`}
          onClick={() => setTab("aktif")}
        >
          Aktif
        </button>

        <button
          className={`btn flex-fill ${tab === "nonaktif" ? "btn-primary" : "btn-outline-secondary"}`}
          onClick={() => setTab("nonaktif")}
        >
          Tidak Aktif
        </button>
      </div>

      <div className="mt-3">


        {loading && (
          <>
            <SkeletonStoreCard />
            <SkeletonStoreCard />
            <SkeletonStoreCard />
          </>
        )}

        {!loading && filtered.length === 0 && (
          <div className="text-center text-muted py-5">
            <h6 className="fw-semibold mb-0">Belum ada toko</h6>
          </div>
        )}

        {!loading &&
          filtered.map((store) => (
            <div
              key={store.id}
              className="card mb-3 border"
              style={{ borderColor: "#dcdcdc" }}
              onClick={() => navigate(`/manage-store/${store.id}`)}
            >
              <div className="card-body d-flex">
                <img
                  src={store.thumbnail}
                  alt={store.name}
                  className="rounded"
                  style={{ width: 110, height: 90, objectFit: "cover" }}
                />

                <div className="ms-3 flex-grow-1">
                  <h6 className="fw-bold mb-1">{store.name}</h6>
                  <small className="text-muted d-block">{store.address}</small>

                  <div className="d-flex justify-content-between mt-2">
                    {store.active ? (
                      <>
                        <span className="text-primary small fw-semibold">
                          {store.posm_active_count} POSM aktif
                        </span>
                        <span className="text-primary small fw-semibold">
                          {store.contract_active_count} Kontrak aktif
                        </span>
                      </>
                    ) : (
                      <span className="text-danger small fw-semibold">
                        Tidak aktif
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ))
        }
      </div>
    </div>
  );
};

export default ManageStorePage;